import React, { useState, useEffect } from 'react';
import Seo from '../components/Seo';
import { seo } from '../seo/seoData';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = (import.meta.env.VITE_CORPORATE_URL || import.meta.env.VITE_BACKEND_URL) + '/api';

const AcceptInvitationPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) setError('Lien d\'invitation invalide.');
  }, [token]);

  const handleSubmit = async () => {
    if (!password || password.length < 8) { setError('Mot de passe minimum 8 caractères.'); return; }
    if (password !== confirm) { setError('Les mots de passe ne correspondent pas.'); return; }
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API_URL}/employees/accept-invitation`, { token, password });
      setSuccess(true);
      setTimeout(() => navigate('/company/login'), 3000);
    } catch(e) {
      setError(e.response?.data?.detail || 'Erreur lors de l\'activation.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
      <Seo {...seo.corporateInvite} />
      <div style={{ background: 'white', borderRadius: 24, padding: 40, width: 420, maxWidth: '90vw', boxShadow: '0 8px 30px rgba(15,23,42,0.08)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#0f172a' }}>BLACK MATTE</div>
          <div style={{ fontSize: 12, color: '#94a3b8', letterSpacing: 3, marginTop: 2 }}>CORPORATE</div>
        </div>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: '#0f172a', marginBottom: 8 }}>Compte activé !</div>
            <div style={{ color: '#64748b', fontSize: 14 }}>Redirection vers la connexion...</div>
          </div>
        ) : (
          <>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: '#0f172a', marginBottom: 8 }}>Créer votre mot de passe</h2>
            <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24 }}>Choisissez un mot de passe pour activer votre compte corporate.</p>

            {error && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: '10px 14px', color: '#dc2626', fontSize: 13, marginBottom: 16 }}>{error}</div>}

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#64748b', marginBottom: 6 }}>Mot de passe</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                style={{ width: '100%', borderRadius: 12, border: '1px solid #e2e8f0', padding: '10px 14px', fontSize: 14, color: '#0f172a', outline: 'none', boxSizing: 'border-box' }}
                placeholder="Minimum 8 caractères" />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#64748b', marginBottom: 6 }}>Confirmer le mot de passe</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                style={{ width: '100%', borderRadius: 12, border: '1px solid #e2e8f0', padding: '10px 14px', fontSize: 14, color: '#0f172a', outline: 'none', boxSizing: 'border-box' }}
                placeholder="Répétez le mot de passe" />
            </div>

            <button onClick={handleSubmit} disabled={loading || !token}
              style={{ width: '100%', background: '#0f172a', color: 'white', border: 'none', borderRadius: 12, padding: '12px 0', fontSize: 15, fontWeight: 600, cursor: loading ? 'wait' : 'pointer' }}>
              {loading ? 'Activation...' : 'Activer mon compte'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptInvitationPage;
